import cx from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

export const ImageFrame = ({ className, src }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <img
        className={styles.image}
        src={src}
        alt=""
      />
    </div>
  );
};

ImageFrame.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
};

ImageFrame.defaultProps = {
  className: '',
};
